import * as React from 'react';
export const IcPlaneDeparture = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.61 7.82A2.06 2.06 0 0019 7.26l-2.76 1.39-6.89-2.59a1 1 0 00-.8.05l-2 1a1 1 0 00-.55.83 1 1 0 00.45.89l4 2.69L8 12.78l-2.45-1.61a1 1 0 00-1-.06l-2 1a1 1 0 00-.505 1.199 1 1 0 00.245.401l2.42 2.41a3 3 0 002.12.88H7a6.29 6.29 0 002.79-.66l11.1-5.55a2 2 0 00.72-2.97z'
      fill='currentColor'
    />
  </svg>
);
